// All font options with Google Fonts URLs
export const FONT_OPTIONS = [
  { id: 'Inter',         label: 'Inter',          url: 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap' },
  { id: 'DM Sans',       label: 'DM Sans',        url: 'https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&display=swap' },
  { id: 'Sora',          label: 'Sora',           url: 'https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&display=swap' },
  { id: 'Plus Jakarta Sans', label: 'Jakarta Sans', url: 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap' },
  { id: 'Manrope',       label: 'Manrope',        url: 'https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700&display=swap' },
  { id: 'IBM Plex Sans', label: 'IBM Plex Sans',  url: 'https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600&display=swap' },
  { id: 'Geist',         label: 'Geist',          url: 'https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700&display=swap' },
  { id: 'Space Grotesk', label: 'Space Grotesk',  url: 'https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&display=swap' },
];

// Preset themes
export const THEME_PRESETS = [
  {
    id: 'lumina',
    label: 'Lumina',
    theme: { accent: '#0d9488', bg: '#f7f9fb', bg2: '#ffffff', bg3: '#f2f4f6', bg4: '#eceef0', font: 'Plus Jakarta Sans', borderRadius: '8px', mode: 'light' },
  },
  {
    id: 'midnight',
    label: 'Midnight',
    theme: { accent: '#f0c040', bg: '#0a0a0a', bg2: '#111111', bg3: '#1a1a1a', bg4: '#222222', font: 'Inter', borderRadius: '10px', mode: 'dark' },
  },
  {
    id: 'obsidian',
    label: 'Obsidian',
    theme: { accent: '#a78bfa', bg: '#080810', bg2: '#0f0f1a', bg3: '#161625', bg4: '#1e1e30', font: 'Sora', borderRadius: '12px', mode: 'dark' },
  },
  {
    id: 'carbon',
    label: 'Carbon',
    theme: { accent: '#4ade80', bg: '#0c0c0c', bg2: '#131313', bg3: '#1c1c1c', bg4: '#242424', font: 'IBM Plex Sans', borderRadius: '6px', mode: 'dark' },
  },
  {
    id: 'ocean',
    label: 'Ocean',
    theme: { accent: '#38bdf8', bg: '#050d1a', bg2: '#0a1628', bg3: '#0f2040', bg4: '#162a50', font: 'Manrope', borderRadius: '12px', mode: 'dark' },
  },
  {
    id: 'slate',
    label: 'Slate',
    theme: { accent: '#f97316', bg: '#0f1117', bg2: '#171b26', bg3: '#1e2333', bg4: '#252b3d', font: 'Plus Jakarta Sans', borderRadius: '10px', mode: 'dark' },
  },
  {
    id: 'pearl',
    label: 'Pearl',
    theme: { accent: '#2563eb', bg: '#f8f8f6', bg2: '#ffffff', bg3: '#f1f0ec', bg4: '#e8e7e2', font: 'DM Sans', borderRadius: '10px', mode: 'light' },
  },
  {
    id: 'cream',
    label: 'Cream',
    theme: { accent: '#d97706', bg: '#faf9f6', bg2: '#ffffff', bg3: '#f5f3ee', bg4: '#ebe8e0', font: 'Manrope', borderRadius: '14px', mode: 'light' },
  },
  {
    id: 'frost',
    label: 'Frost',
    theme: { accent: '#0891b2', bg: '#f0f4f8', bg2: '#ffffff', bg3: '#e8edf2', bg4: '#dce3ea', font: 'Inter', borderRadius: '12px', mode: 'light' },
  },
];

// Accent colour swatches
export const ACCENT_SWATCHES = [
  { color: '#f0c040', label: 'Gold' },
  { color: '#a78bfa', label: 'Purple' },
  { color: '#4ade80', label: 'Green' },
  { color: '#60a5fa', label: 'Blue' },
  { color: '#f87171', label: 'Red' },
  { color: '#fb923c', label: 'Orange' },
  { color: '#f472b6', label: 'Pink' },
  { color: '#34d399', label: 'Teal' },
  { color: '#38bdf8', label: 'Sky' },
  { color: '#facc15', label: 'Yellow' },
  { color: '#a3e635', label: 'Lime' },
  { color: '#e879f9', label: 'Fuchsia' },
];

export const RADIUS_OPTIONS = [
  { id: '4px',  label: 'Sharp' },
  { id: '8px',  label: 'Soft' },
  { id: '12px', label: 'Rounded' },
  { id: '16px', label: 'Pill' },
];

// Load a font dynamically
const loadedFonts = new Set();
export function loadFont(fontId) {
  const opt = FONT_OPTIONS.find(f => f.id === fontId);
  if (!opt || loadedFonts.has(fontId)) return;
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = opt.url;
  document.head.appendChild(link);
  loadedFonts.add(fontId);
}

// Apply theme to document CSS variables
export function applyTheme(theme) {
  const root = document.documentElement;
  const isDark = theme.mode === 'dark';

  // Load font first so it's ready when applied
  loadFont(theme.font);

  root.style.setProperty('--bg',  theme.bg);
  root.style.setProperty('--bg2', theme.bg2);
  root.style.setProperty('--bg3', theme.bg3);
  root.style.setProperty('--bg4', theme.bg4);
  root.style.setProperty('--accent',  theme.accent);
  root.style.setProperty('--accent2', darken(theme.accent, 15));
  root.style.setProperty('--radius',  theme.borderRadius);
  root.style.setProperty('--radius-lg', bump(theme.borderRadius, 4));
  root.style.setProperty('--font', `'${theme.font}', 'Inter Tight', sans-serif`);
  // STR type system — serif display, sans text, mono for figures/labels
  root.style.setProperty('--font-ui', "'Inter Tight', -apple-system, BlinkMacSystemFont, sans-serif");
  root.style.setProperty('--mono',    "'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace");
  root.style.setProperty('--serif',   "'Playfair Display', 'Georgia', serif");
  root.style.setProperty('--mark',    "'Bodoni Moda', 'Didot', 'Bodoni 72', Georgia, serif");

  if (isDark) {
    // STR brand neutrals — bone type, hairline borders, near-flat elevation
    root.style.setProperty('--text',   '#EFEBE4');                 // bone (never pure white)
    root.style.setProperty('--text2',  'rgba(239,235,228,0.78)');
    root.style.setProperty('--text3',  'rgba(239,235,228,0.58)');
    root.style.setProperty('--border', 'rgba(239,235,228,0.12)');  // hairline
    root.style.setProperty('--border2','rgba(239,235,228,0.20)');
    root.style.setProperty('--primary',  theme.accent);
    root.style.setProperty('--primary2', darken(theme.accent, 12));
    root.style.setProperty('--shadow-card',  '0 1px 0 rgba(0,0,0,0.35)');
    root.style.setProperty('--shadow-soft',  'none');
    root.style.setProperty('--shadow-pop',   '0 24px 60px rgba(0,0,0,0.55)');
    root.style.setProperty('--shadow-hover', '0 2px 0 rgba(0,0,0,0.35)');
  } else {
    root.style.setProperty('--text',   '#191c1e');
    root.style.setProperty('--text2',  '#45464d');
    root.style.setProperty('--text3',  '#64748b');
    root.style.setProperty('--border', '#e2e8f0');
    root.style.setProperty('--border2','#cbd5e1');
    // Lumina: navy is primary (buttons/branding), accent (teal) stays interactive
    root.style.setProperty('--primary',  '#0f172a');
    root.style.setProperty('--primary2', '#1e293b');
    root.style.setProperty('--shadow-card',  '0 4px 20px rgba(15,23,42,0.04)');
    root.style.setProperty('--shadow-soft',  '0 1px 3px rgba(15,23,42,0.06)');
    root.style.setProperty('--shadow-pop',   '0 10px 30px rgba(15,23,42,0.08)');
    root.style.setProperty('--shadow-hover', '0 12px 28px rgba(15,23,42,0.10)');
  }

  document.body.style.background = theme.bg;
  document.body.style.fontFamily = `'${theme.font}', sans-serif`;
}

// Helpers
function darken(hex, pct) {
  if (!hex || hex.length < 7) return hex || '#000000';
  const n = parseInt(hex.slice(1), 16);
  if (isNaN(n)) return hex;
  const r = Math.max(0, (n >> 16) - pct * 2.55) | 0;
  const g = Math.max(0, ((n >> 8) & 0xff) - pct * 2.55) | 0;
  const b = Math.max(0, (n & 0xff) - pct * 2.55) | 0;
  return '#' + [r, g, b].map(x => x.toString(16).padStart(2,'0')).join('');
}

function bump(radius, px) {
  const n = parseInt(radius);
  return `${n + px}px`;
}
